import React from 'react';
import { Box, createStyles, makeStyles } from '@material-ui/core';
import { Children, ExtendedTheme } from 'neon-design-system';

const useStyles = makeStyles((theme: ExtendedTheme) => createStyles({
	root: {
		[theme.breakpoints.down('md')]: {
			paddingRight: theme.spacing(2),
			paddingLeft: theme.spacing(2)
		}
	}
}));

interface ContainerNoScrollProps {
	children: Children;
}


export const ContainerNoScroll = ({ children }: ContainerNoScrollProps) => {
	const classes = useStyles();

	return (
		<Box className={classes.root}>
			{children}
		</Box>
	);
}

export default ContainerNoScroll;
